import { company_name } from "@/i18n/variables";

const sign_up = {
	/* -------------------------------------------------------------------------- */
	/*                                FORM SECTION                                */
	/* -------------------------------------------------------------------------- */
	form: {
		confirmation: {
			description:
				"Your new account has been successfully registered. To ensure we can reach you, we have sent an email confirmation. You can now close this page.",
			title: "Email confirmation sent",
		},
		debtor_info: {
			description:
				"Ask a colleague with an account to create an account for you unless this is the first time your company is using Portal. Then you can log in once with the login details you use for klanten.tuxis.nl. Forgot the klanten.tuxis.nl password? Read how to reset it <password_reset_link>here</password_reset_link>.",
			title: "You don't need to create an account!",
		},
		descriptions: {
			billing: "This is where the invoice will be sent.",
			debtor:
				"Enter your personal information below to create an account. Business users can later add other individuals or colleagues.",
		},
		foreign_private_debtor_warning: "Please note! You can only use free services.",
		labels: {
			accept_conditions: "I accept the",
			has_debtor_code: "Do you already have a debtor number?",
			privacy_policy: "terms and conditions",
		},
		password_strength: {
			bad: "Bad",
			good: "Good",
			medium: "Moderate",
			okay: "Okay",
			passwords_no_match: "Passwords do not match!",
			too_short: "Too Short",
		},
		progress_bar: {
			address: "Address and Company Information",
			debtor: "Personal Information",
		},
		terms: {
			label: "Terms and Conditions",
			text: {
				part1: "I agree to the",
				part2: "terms and conditions",
				part3: `of ${company_name}`,
			},
		},
		tips: {
			debtor_code: `You can find your debtor number on every invoice you receive from ${company_name}. This number starts with DB and ends with 4 digits.`,
		},
		titles: {
			account: "Your Account Information",
			address: "Customer Address",
			billing: "Billing Information",
			debtor: "Your Personal Information",
			user: "Your Login Details",
		},
		values: {
			no: "No",
			yes: "Yes",
		},
	},

	verification: {
		account_verification_card: {
			body: "Use the link below to complete a €0.01 payment to verify your details. If you are unable to do this yourself, you may also forward the link to someone else.\nAfter the payment, you will receive an email confirming that your account has been activated.",
			button: "Start verification payment (€0.01)",
			title: "Account Verification",
		},
	},
};

export default sign_up;
